import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import PDFObject from "pdfobject";

class PdfViewer extends PureComponent {
  static propTypes = {
    url: PropTypes.string.isRequired,
    width: PropTypes.string,
    height: PropTypes.string,
  };

  componentDidMount() {
    this.embedPDF();
  }

  embedPDF = () => {
    if (this.container) {
      PDFObject.embed(this.props.url, this.container);
    }
  };

  render() {
    const { width = "100%", height = "1000px" } = this.props;

    this.embedPDF();

    return (
      <div
        ref={container => {
          this.container = container;
        }}
        style={{ width, height }}
      />
    );
  }
}

export default PdfViewer;
